import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  ORDER_REFUND_COUNT,
  ORDER_REFUND_REPORT,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  OrderRefundData: [],
  status: false,
  successMessage: "",
  error: "",

  countLoading: false,
  countData: 10,
};

let abortOrderRefund = null;
let abortOrderRefundCount = null;

// Generate pening , fulfilled and rejected action type
export const fetchOrderRefundData = createAsyncThunk(
  "OrderRefundDataList/fetchOrderRefundData.",
  async (data, { rejectWithValue }) => {
    try {
      if (abortOrderRefund) {
        abortOrderRefund.abort();
      }

      abortOrderRefund = new AbortController();
      const signal = abortOrderRefund.signal;

      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + ORDER_REFUND_REPORT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response.data.status === true) {
        const arr = response.data.report_data;
        const status = response.data.status;
        return { arr, status };
      } else if (response.data.status === false) {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchOrderRefundCount = createAsyncThunk(
  "products/fetchOrderRefundCount",
  async (payload, { rejectWithValue }) => {
    const { token, ...dataNew } = payload;
    try {
      if (abortOrderRefundCount) {
        abortOrderRefundCount.abort();
      }

      abortOrderRefundCount = new AbortController();
      const signal = abortOrderRefundCount.signal;

      const response = await axios.post(
        BASE_URL + ORDER_REFUND_COUNT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response?.data?.status) {
        return response?.data?.total_count;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const OrderRefundReportSlice = createSlice({
  name: "OrderRefundDataList",
  initialState,
  reducers: {
    upadateStateOfOrderRefundReport: (state) => {
      state.OrderRefundData = [];
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrderRefundData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrderRefundData.fulfilled, (state, action) => {
      state.loading = false;
      state.OrderRefundData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchOrderRefundData.rejected, (state, action) => {
      state.loading = false;
      state.OrderRefundData = {};
      state.error = action.error.message;
    });

    builder.addCase(fetchOrderRefundCount.pending, (state) => {
      state.countLoading = true;
    });
    builder.addCase(fetchOrderRefundCount.fulfilled, (state, action) => {
      state.countLoading = false;
      state.countData = action.payload;
    });
    builder.addCase(fetchOrderRefundCount.rejected, (state, action) => {
      state.countLoading = false;
      state.countData = 10;
    });
  },
});
export const { upadateStateOfOrderRefundReport } =
  OrderRefundReportSlice.actions;
export default OrderRefundReportSlice.reducer;
